import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../api/axios';
import '../index.css';

const FORGOT_URL = '/auth/forgot-password';

const ForgotPassword = () => {
  const userRef = useRef();
  const errRef = useRef();
  const [user, setUser] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg('');
    setSuccessMsg('');

    if (!user.trim()) {
      setErrMsg('Enter your username or email.');
      errRef.current.focus();
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        FORGOT_URL,
        JSON.stringify({ user: user.trim() }),
        { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
      );
      setSuccessMsg(response?.data?.message || 'Check your email for reset instructions.');
      setUser('');
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No server response. Try again later.');
      } else {
        setErrMsg(err.response?.data?.message || 'Could not start password reset.');
      }
      errRef.current.focus();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="btn" className="App">
      <section>
        <p ref={errRef} className={errMsg ? 'errmsg' : 'offscreen'} aria-live="assertive">{errMsg}</p>
        <p className={successMsg ? 'line' : 'offscreen'} aria-live="polite">{successMsg}</p>

        <h1>Forgot password</h1>
        <p className="line">
          Enter your username or the email on your account. If we find a match, reset instructions will be sent.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="username">Username or email</label>
          <input
            type="text"
            id="username"
            ref={userRef}
            autoComplete="username"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            required
          />
          <button className="button" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send reset link'}
          </button>
        </form>

        <p>
          Remembered it?<br />
          <Link to="/login">Back to sign in</Link>
        </p>
        <p>
          Need an account?<br />
          <Link to="/register">Sign up</Link>
        </p>
      </section>
    </div>
  );
};

export default ForgotPassword;